module.exports = fox._r("images/press/tsm-img-2.png", __webpack_public_path__ + "_/common/images/press/tsm-img-2.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/tsm-img-2.png
// module id = 413
// module chunks = 2